import { Component, inject } from "@angular/core";
//import { Auth, signInWithPopup, signInWithRedirect, getAuth } from '@angular/fire/auth';
//import { GoogleAuthProvider } from "firebase/auth";
import { Router } from "@angular/router";

import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatGridListModule } from "@angular/material/grid-list";
import { LoginService } from "./login.service";
import { getLocalStorage } from "../local-storage";
import { AuthService } from "../services/login/auth.service";
import {
  Auth,
  signInWithPopup,
  signInWithRedirect,
  getAuth,
} from "@angular/fire/auth";
import { AlertaService } from "../alerta/alerta.service";
import { UsuarioService } from "../usuario/usuario.service";
import { firstValueFrom } from "rxjs";
import { AppState } from "../app.state";
import { Store } from "@ngrx/store";
import { resetStore } from "../states/login/actions";

@Component({
  selector: "app-login",
  standalone: true,
  imports: [MatButtonModule, MatCardModule, MatGridListModule],
  templateUrl: "./login.component.html",
  styleUrl: "./login.component.css",
})
export class LoginComponent {
  router = inject(Router);
  authService = inject(AuthService);
  loginService = inject(LoginService);
  alertaSevice = inject(AlertaService);
  usuarioService = inject(UsuarioService);
  store: Store<AppState> = inject(Store);
  private emailPattBal = new RegExp("@bal.com.mx");
  private emailPattGNP = new RegExp("@gnp.com.mx");
  private emailPattGmail = new RegExp("@gmail.com");
  private emailPattProveedor = new RegExp("@proveedoresgnp.mx");
  private emailPattGtec = new RegExp("@gtec.com.mx");

  ngOnInit(): void {
    this.store.dispatch(resetStore());
  }

  async login() {
    const result: any = await this.loginService.loginPopup();
    if (!result.error) {
      const user_uid = result.uid;
      const user_email: string = result.email;

      this.store.dispatch(resetStore());

      if (
        result.uid &&
        (this.emailPattBal.test(result.email) ||
          this.emailPattGNP.test(result.email) ||
          this.emailPattGmail.test(result.email) ||
          this.emailPattGtec.test(result.email) ||
          this.emailPattProveedor.test(result.email))
      ) {
        const oUsuario: any = await firstValueFrom(
          this.usuarioService.getUsuario()
        );

        if (oUsuario !== null && oUsuario?.activo) {
          this.usuarioService.setUsuario(oUsuario);
          const localStorage = getLocalStorage();
          const token = result.token ? result.token : "null";
          localStorage?.setItem("user", token.toString());
          this.authService.login(token.toString(), "");
          this.router.navigate(["/agenda"]);
        } else {
          this.alertaSevice.open("Error", "Usuario no válido.");
          this.logout();
        }
      } else {
        this.alertaSevice.open(
          "Error",
          "El dominio de la cuenta no pertence a GNP."
        );
        this.logout();
      }
    } else {
      this.logout();
      console.log(result.error);
      this.alertaSevice.open("Error", this.getMenssageCode(result.error.code));
    }
  }

  logout() {
    this.loginService.logout();
  }

  getMenssageCode(code: string) {
    var mensaje = "Tenemos incovenientes con tu acceso!!!";
    switch (code) {
      case "auth/network-request-failed":
        mensaje = "Comprueba tu conexión a internet y vuelve a intentarlo.";
        break;
      case "auth/user-not-found":
        mensaje = "La contraseña o el usuario no es válido.";
        break;
      case "auth/wrong-password":
        mensaje = "La contraseña o el usuario no es válido.";
        break;
      case "auth/user-disabled":
        mensaje = "El usuario ha sido deshabilitado.";
        break;
      case "auth/cancelled-popup-request":
        mensaje = "El popup de login ha sido cancelado.";
        break;
    }

    return mensaje;
  }
}
